<script lang="ts">
	import Logo from "../Logo.svelte";
	import { onMount, tick } from "svelte";
	import { goto, yyyy, zzzz } from "../store.svelte";
	import { toast } from "../lib/toast.svelte.ts";
	import { fly } from "svelte/transition";
	// import { jwtDecode } from "jwt-decode";

	const url: string = yyyy.uri.api;
	let ready: boolean = $state(false);
	let inemail: string = $state("");
	let inpass: string = $state("");
	let shake: boolean = $state(false);
	let isdanger: boolean = $state(false);
	let emailbox: HTMLInputElement | undefined = $state();
	let passbox: HTMLInputElement | undefined = $state();
	let procedure: number = $state(0);
	let firstpass: string = $state("");
	let waiting: boolean = $state(false);
	let isreset: boolean = $state(false);
	let new_forgot_code: string = $state("");
	// let secondpass: string;

	let cancelBox = () => {
		goto("/");
	};

	const handleSignUp = async () => {
		if (procedure === 0) {
			procedure = 1;
			await tick();
			passbox?.focus();
			return;
		}

		if (procedure === 1) {
			procedure = 2;
			firstpass = inpass;
			inpass = "";
			await tick();
			passbox?.focus();
			return;
		}

		yyyy.usage = "wait";
		waiting = true;
		const _body = JSON.stringify({ email: inemail, pass: inpass });
		const _header = { "Content-Type": "application/json" };
		const resp = await fetch(`${url}/rpc/signup`, {
			method: "post",
			body: _body,
			headers: _header,
		});

		if (resp.ok) {
			toast.success("Sign Up successful. Check your email for a confirmation link.");
			goto("/");
		} else {
			let errmsg = await resp.json();
			shake = true;
			if (errmsg.code === "23505") {
				toast.warning(
					"You already have an account. Maybe you forgot your password?"
				);
				goto("/sign-in");
				return;
			} else if (errmsg.code === "22023") {
				toast.warning(
					`${inemail} does not appear to be a valid email address.`
				);
				waiting = false;
				procedure = 0;
				inemail = "";
				inpass = "";

				return;
			} else {
				toast.error(
					"Something went wrong.....try again later.",
					undefined,
					"top-center"
				);
			}
			console.log(errmsg);

			setTimeout(() => {
				shake = false;
				yyyy.logo.usage = "logo";
			}, 750);
		}
	};

	const handleResetCode = async (forgot_code: string) => {
		console.log("forgot_code is:", forgot_code);
		isreset = true;

		const _body = JSON.stringify({ forgot_code: forgot_code });
		const _header = { "Content-Type": "application/json" };
		const resp = await fetch(`${url}/rpc/reset`, {
			method: "post",
			body: _body,
			headers: _header,
		});

		if (resp.ok) {
			let data = await resp.json();
			console.log("data is: ", data);
			toast.success("Enter your new password.", undefined, "top-center");

			inemail = data.message.email;
			new_forgot_code = data.message.forgot_code;
			ready = true;
			//setTimeout(() => {procedure = 1}, 875)
			procedure = 1;
			console.log("inemail is: ", inemail);
		} else {
			toast.error(
				"There was an issue with reseting your password. Please try again.",
				undefined,
				"top-center"
			);
			goto("/");
		}
	};

	const resetPass = async (the_forgot_code: string, new_pass: string) => {
		console.log("forgot_code is:", the_forgot_code);
		isreset = true;

		const _body = JSON.stringify({
			forgot_code: the_forgot_code,
			new_pass: new_pass,
		});
		const _header = { "Content-Type": "application/json" };
		const resp = await fetch(`${url}/rpc/reset`, {
			method: "post",
			body: _body,
			headers: _header,
		});

		if (resp.ok) {
			let data = await resp.json();
			console.log("data is: ", data);
			toast.success("Password reset succesful.", undefined, "top-center");
			goto("/");
		} else {
			toast.error(
				"There was an issue resetting your password. Please try again"
			);

			goto("/");
		}
	};
	const handleConfCode = async (conf_code: string) => {
		console.log("confcode is:", conf_code);

		const _body = JSON.stringify({ conf_code: conf_code });
		const _header = { "Content-Type": "application/json" };
		const resp = await fetch(`${url}/rpc/confirm`, {
			method: "post",
			body: _body,
			headers: _header,
		});

		if (resp.ok) {
			toast.success("Email confirmed. You can now signin.", undefined, "top-center");
			goto("/sign-in");
		} else {
			toast.error(
				"There was an issue with your confirmation code.",
				undefined,
				"top-center"
			);

			goto("/");
		}
	};

	let emailValidity = () => {
		console.log("validity");
		if (!emailbox.validity.valid) {
			alert("email not valid");
		}
	};

	let enterPressed = (event: KeyboardEvent) => {
		if (
			event.key === "Enter" &&
			event.target.id === "email" &&
			inemail !== undefined
		) {
			event.preventDefault(); // Prevent default form submission
			handleSignUp();
		}

		if (
			event.key === "Enter" &&
			event.target.id === "password" &&
			inpass !== undefined
		) {
			event.preventDefault(); // Prevent default form submission
			handleSignUp();
		}
	};

	onMount(() => {
		if (yyyy.params && yyyy.params.has("confirm")) {
			handleConfCode(yyyy.params.get("confirm"));
		} else if (yyyy.params && yyyy.params.has("forgot")) {
			yyyy.logo.usage = "logo";
			handleResetCode(yyyy.params.get("forgot"));
		} else {
			setTimeout(async () => {
				ready = true;
				yyyy.logo.usage = "logo";
				await tick(); // Wait until the DOM has been updated
				emailbox.focus();
			}, 250);
		}
	});
</script>

<div class="column is-one-quarter porridge">
	{#if ready}
		<div class="card lvwr-card" class:shake>
			<div
				transition:fly|local={{ y: -200 }}
				class="card-content lvwr-card-content"
			>
				<h1 class="title thin lvwr-title">Livewire</h1>
				<h2 class="subtitle lvwr-subtitle">
					Power Delivery Modelling in the Cloud by
				</h2>
				<div class="content">
					<Logo usage={yyyy.logo.usage} interact={false} />
				</div>
				<div class="content">
					<div class="field">
						{#if procedure === 0}<label class="label" for="email"
								>Enter your email address</label
							>{/if}
						<div class="control">
							<input
								id="email"
								class="input"
								class:is-danger={isdanger}
								class:is-static={procedure > 0}
								type="email"
								placeholder="email address"
								bind:value={inemail}
								bind:this={emailbox}
								onkeypress={enterPressed}
							/>
						</div>
						<p class="help is-success"></p>
					</div>
					{#if procedure > 0}
						<div class="field">
							{#if procedure === 1}<label class="label" for="password"
									>Enter your password</label
								>{/if}
							{#if procedure === 2}<label class="label" for="password"
									>confirm your password</label
								>{/if}
							<div class="control">
								<input
									id="password"
									class="input"
									class:is-danger={isdanger}
									type="password"
									placeholder="password"
									bind:value={inpass}
									bind:this={passbox}
									onkeypress={enterPressed}
								/>
							</div>
							<p class="help is-success"></p>
						</div>
					{/if}
				</div>
			</div>
			<footer transition:fly|local={{ y: 200 }} class="card-footer">
				<div class="card-footer-item sign-in-cancel-footer">
					<button onclick={cancelBox} tabindex="-1" class="button lvwr-toggle-cancel"
						>Cancel</button
					>
					{#if procedure === 0}
						<button
							onclick={handleSignUp}
							disabled={!inemail}
							class="button lvwr-toggle">Next</button
						>{/if}

					{#if procedure === 1}
						<button
							onclick={handleSignUp}
							disabled={!inpass}
							class="button lvwr-toggle">Next</button
						>
					{/if}

					{#if procedure === 2 && !isreset}
						<button
							onclick={handleSignUp}
							disabled={inpass !== firstpass}
							class="button lvwr-toggle"
							class:is-loading={waiting}>Sign Up</button
						>{/if}

					{#if procedure === 2 && isreset}
						<button
							onclick={() => {
								resetPass(new_forgot_code, inpass);
							}}
							disabled={inpass !== firstpass}
							class="button lvwr-toggle"
							class:is-loading={waiting}>Reset password</button
						>{/if}
				</div>
			</footer>
		</div>
	{/if}
</div>

<style>
	.porridge {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		height: fit-content;
		z-index: 5;
	}

	input {
		cursor: #ff3e00;
	}

	.lvwr-card-content {
		height: 410px;
	}

	.shake {
		animation: shake 0.75s;
		animation-iteration-count: 2s;
	}

	@keyframes shake {
		0% {
			transform: translate(1px, 1px) rotate(0deg);
		}
		10% {
			transform: translate(-1px, -2px) rotate(-5deg);
		}
		20% {
			transform: translate(-3px, 0px) rotate(5deg);
		}
		30% {
			transform: translate(3px, 2px) rotate(0deg);
		}
		40% {
			transform: translate(1px, -1px) rotate(3deg);
		}
		50% {
			transform: translate(-1px, 2px) rotate(-3deg);
		}
		60% {
			transform: translate(-3px, 1px) rotate(0deg);
		}
		70% {
			transform: translate(3px, 1px) rotate(-2deg);
		}
		80% {
			transform: translate(-1px, -1px) rotate(2deg);
		}
		90% {
			transform: translate(1px, 2px) rotate(0deg);
		}
		100% {
			transform: translate(1px, -2px) rotate(0deg);
		}
	}
</style>
